import type { RouterScrollBehavior } from "vue-router";

export const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition && !to.meta.scrollTop) return savedPosition;
  if (to.hash) return { el: to.hash, behavior: 'smooth' };

  return { el: '#app-main', top: 0 };
}
